








































import Vue from "vue";

export default Vue.extend({
  props: {
    question: { type: String, required: true },
    answer: { type: String, required: true },
    showLink: { type: Boolean, required: true },
    link: { type: String, required: false },
    link2: { type: String, required: false },
    linkText: { type: String, required: false },
    link2Text: { type: String, required: false },
  },
});
